// client/src/components/servicos/ServicoRow.js - VERSÃO 100% COMPLETA E CORRIGIDA
import React, { memo } from 'react';
import { MoreVertical } from 'lucide-react';
import { useTenantI18n } from '../../hooks/useAccounts';
import { formatCurrency } from '../../utils/formatters';

const ServicoRow = memo(({
    servico,
    onOpenActions,
    loading
}) => {
    const servicoId = servico._id || servico.id;
    // ✅ ACHADO: as 3 chamadas abaixo eram fixas em BRL, sem ler
    // configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();

    const getCategoriaNome = () => {
        if (!servico.categoria) return 'Sem categoria';
        if (typeof servico.categoria === 'object') {
            return servico.categoria.nome || 'Categoria sem nome';
        }
        return servico.categoria || 'Sem categoria';
    };

    const getPrecoFormatado = () => {
        if (servico.valorFixo !== undefined && servico.valorFixo !== null) {
            return formatCurrency(servico.valorFixo, currency, locale);
        }

        if (servico.precoBase !== undefined && servico.precoBase !== null) {
            return formatCurrency(servico.precoBase, currency, locale);
        }

        if (Array.isArray(servico.unidadesDetalhes) && servico.unidadesDetalhes.length > 0) {
            const primeiroPreco = servico.unidadesDetalhes[0]?.precoPersonalizado;
            if (primeiroPreco !== undefined && primeiroPreco !== null) {
                return formatCurrency(primeiroPreco, currency, locale);
            }
        }

        return 'Não definido';
    };

    const getStatusInfo = () => {
        const ativo = servico.ativo !== false;
        return {
            texto: ativo ? 'Ativo' : 'Inativo',
            cor: ativo ? 'text-green-600 bg-green-100' : 'text-red-600 bg-red-100',
            badge: ativo ? 'badge-success' : 'badge-danger'
        };
    };

    const getTipoServico = () => {
        const tipo = servico.metadata?.tipoServico || 'interno';
        return tipo === 'interno' ? 'Interno' : 'Externo';
    };

    const statusInfo = getStatusInfo();

    if (!servico || !servicoId) {
        console.error('❌ [SERVICO_ROW] Serviço inválido:', servico);
        return null;
    }

    return (
        <tr className="table-row">
            <td className="table-cell">
                <div className="flex items-center">
                    <span className="font-medium">{servico.nome || 'Sem nome'}</span>
                </div>
            </td>
            
            <td className="table-cell">
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                    {getCategoriaNome()}
                </span>
            </td>
            
            <td className="table-cell">
                <span className={`text-xs px-2 py-1 rounded-full ${
                    getTipoServico() === 'Interno' 
                        ? 'bg-purple-100 text-purple-800' 
                        : 'bg-orange-100 text-orange-800'
                }`}>
                    {getTipoServico()}
                </span>
            </td>
            
            <td className="table-cell">
                <span className={`text-xs px-2 py-1 rounded-full ${
                    statusInfo.badge === 'badge-success' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                }`}>
                    {statusInfo.texto}
                </span>
            </td>
            
            <td className="table-cell">
                <div className="space-y-1">
                    <div className="text-sm">
                        <span className="font-semibold text-green-600">
                            {getPrecoFormatado()}
                        </span>
                    </div>
                </div>
            </td>
            
            <td className="text-right">
                <button
                    onClick={() => onOpenActions(servico)}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading}
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
});

ServicoRow.displayName = 'ServicoRow';

export default ServicoRow;